import axiosBackendInstance from '../axiosBackendInstance'
import axiosInstance from '../axiosInstance'

export type UploadImageParams = {
	props: {
		imageKey: string
		bucket: string
		imageKeyPrev?: string
		nextPublicSecretToken?: string
	}
	file?: File | Blob
	buffer?: Buffer
	contentType?: string
	andThen?: Function
	env: string
}

const uploadImage = async (propsAndFile: UploadImageParams) => {
	try {
		const presignResponse = await axiosBackendInstance(propsAndFile.env)({
			method: 'post',
			url: 'presignImageUrl',
			data: propsAndFile.props,
			headers: {
				crossDomain: true,
			},
		})
		try {
			console.log('sent put type:', propsAndFile.file ?? propsAndFile.buffer)

			const uploadResponse = await axiosInstance({
				method: 'put',
				url: presignResponse.data,
				data: propsAndFile.file ?? propsAndFile.buffer,
				withCredentials: false,
				headers: {
					'x-amz-acl': 'public-read',
					'Content-Type': propsAndFile?.contentType ?? propsAndFile?.file?.type,
				},
			})
			if (propsAndFile.andThen) {
				return propsAndFile.andThen()
			} else {
				return {
					presignResponse,
					uploadResponse,
				}
			}
		} catch (error) {
			console.error(error)
			return {
				presignResponse,
			}
		}
	} catch (error) {
		console.error(error)

		return {}
	}
}

export default uploadImage
